import { useMemo } from 'preact/hooks'
import { useSearchspringContext } from '../fetchers/provider'
import { useOption } from '../hooks/useOption'
import Icon from '@/components/snippets/icon/icon'
import clsx from 'clsx'

export function FilterSort({ name = 'sort', buttonClass = 'underline btn btn-text-black btn-md btn-inline whitespace-nowrap', direction = 'down' }) {
  const { results, refine } = useSearchspringContext()

  const sorts = useMemo(() => {
    return (
      results?.sorting?.options?.map((option) => ({
        label: option.label,
        value: `${option.field}:${option.direction}`
      })) ?? []
    )
  }, [results])

  const activeSort = useOption('sort', {
    defaultValue: sorts?.[0]?.value,
    syncWithURL: true
  })

  const activeSortLabel = useMemo(() => {
    const sort = sorts.find((sort) => sort.value === activeSort) ?? sorts[0]
    return sort?.label
  }, [activeSort, sorts])

  return (
    <x-modal className="relative group">
      <button data-modal-role="toggle" className={buttonClass}>
        <Icon id="arrow-up-down" />
        <div className="flex">
          <span>Sort By</span>
          <span className="hidden md:block">: {activeSortLabel}</span>
        </div>
      </button>
      <button
        data-modal-role="close"
        class="
        pointer-events-none fixed inset-0 z-30
        bg-black/60 opacity-0 transition-all
        group-data-visible:pointer-events-auto group-data-visible:opacity-100"
      />
      <div className={clsx('absolute right-0 z-40 flex flex-col overflow-hidden transition-all bg-white max-h-0 w-72 group-data-visible:max-h-96 md:w-80', direction === 'down' ? 'top-full' : 'bottom-full')}>
        <div className="flex justify-between p-6">
          <p className="h4">Sort</p>
          <button data-modal-role="close">
            <Icon id="close" />
          </button>
        </div>
        <div className="px-4 py-2 md:px-6">
          {sorts?.map((sort) => (
            <div className="flex items-center h-6 gap-2 mb-6">
              <input
                id={`sort__${sort.value}`}
                type="radio"
                value={sort.value}
                name={name}
                onClick={() => refine('sort', sort.value)}
                checked={activeSort === sort.value}
                className="field-radio"
              />
              <label for={`sort__${sort.value}`} className="paragraph-md text-neturals-secondary-grey">
                {sort.label}
              </label>
            </div>
          ))}
        </div>
      </div>
    </x-modal>
  )
}
